import { getMomentTz } from "@dexteel/mesf-core";
import { Grid, IconButton, MenuItem, TextField } from "@mui/material";
import { ArrowBackRounded, ArrowForwardRounded } from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers";
import React from "react";

const moment = getMomentTz();

const DAYS_OPTIONS = [
  { value: 1, label: "1 day" },
  { value: 3, label: "3 days" },
  { value: 7, label: "7 days" },
  { value: 30, label: "30 days" },
];

interface DateRangeFilterProps {
  selectedDate: moment.Moment;
  selectedDays: number;
  onDateChange: (date: moment.Moment | null) => void;
  onDaysChange: (days: number) => void;
  onNavigate: (direction: "prev" | "next") => void;
}

export const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  selectedDate,
  selectedDays,
  onDateChange,
  onDaysChange,
  onNavigate,
}) => {
  const isToday = selectedDate.isSame(moment(), "day");

  return (
    <>
      <Grid item>
        <IconButton
          onClick={() => onNavigate("prev")}
          size="small"
          title={`Go back ${selectedDays} ${
            selectedDays === 1 ? "day" : "days"
          }`}
        >
          <ArrowBackRounded />
        </IconButton>
      </Grid>

      <Grid item xs={4} sm={3} md={3}>
        <DatePicker
          label="Date"
          value={selectedDate}
          onChange={onDateChange}
          slotProps={{
            textField: {
              fullWidth: true,
              variant: "outlined",
              size: "small",
              InputLabelProps: {
                shrink: true,
              },
            },
          }}
        />
      </Grid>

      <Grid item xs={3} sm={2} md={2}>
        <TextField
          select
          label="Period"
          variant="outlined"
          size="small"
          fullWidth
          value={selectedDays}
          onChange={(event) => onDaysChange(Number(event.target.value))}
          sx={{ "& .MuiSelect-select": { cursor: "pointer" } }}
        >
          {DAYS_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item>
        <IconButton
          onClick={() => onNavigate("next")}
          size="small"
          disabled={isToday}
          title={`Go forward ${selectedDays} ${
            selectedDays === 1 ? "day" : "days"
          }`}
        >
          <ArrowForwardRounded />
        </IconButton>
      </Grid>
    </>
  );
};
